export enum FormType {
  AUTOCOMPLETE = 'AUTOCOMPLETE',
  AUTOCOMPLETE_TAG = 'AUTOCOMPLETE_TAG',
  INPUT = 'INPUT',
  DROPDOWN = 'DROPDOWN',
  TEXT_AREA = 'TEXT_AREA',
  CHECKBOXES = 'CHECKBOXES',
  YES_NO = 'YES_NO',
  FORM_TITLE = 'FORM_TITLE',
  MONTH_DATE_PICKER = 'MONTH_DATE_PICKER',
  BUTTON_GROUP = 'BUTTON_GROUP',
  MONTH_YEAR_PERIOD = 'MONTH_YEAR_PERIOD',
}

export enum YesNo {
  YES = 'Yes',
  NO = 'No',
}
